var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatasheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "96.000000pt",
    height: "96.000000pt",
    viewBox: "0 0 96.000000 96.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,96.000000) scale(0.100000,-0.100000)",
    fill: "#F0F0F0",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185 855 c-24 -23 -25 -30 -25 -140 0 -97 -2 -115 -15 -115 -9 0 -27 -11 -40 -25 -24 -23 -25 -29 -25 -155 0 -126 1 -132 25 -155 13 -14 31 -25 40 -25 12 0 15 -12 15 -55 0 -46 4 -60 25 -80 l24 -25 271 0 271 0 24 25 25 24 0 278 0 278 -98 98 -97 97 -198 0 c-197 0 -198 0 -222 -25z m375 -135 l0 -80 80 0 c73 0 80 -2 80 -20 0 -19 -7 -20 -240 -20 l-240 0 0 100 0 100 160 0 160 0 0 -80z m-337 -230 c6 -16 14 -30 17 -30 3 0 11 14 17 30 9 23 18 30 37 30 l26 0 -25 -50 -25 -50 25 -50 25 -50 -26 0 c-19 0 -28 7 -37 30 -6 17 -14 30 -17 30 -3 0 -11 -13 -17 -30 -9 -23 -18 -30 -37 -30 l-26 0 25 50 25 50 -25 50 -25 50 26 0 c19 0 28 -7 37 -30z m177 -50 l0 -80 40 0 c33 0 40 -3 40 -20 0 -18 -7 -20 -60 -20 l-60 0 0 100 c0 93 1 100 20 100 18 0 20 -7 20 -80z m220 60 c11 -11 20 -24 20 -30 0 -16 -32 -11 -45 7 -7 9 -17 13 -23 9 -21 -13 -13 -34 23 -54 42 -26 55 -64 30 -92 -18 -20 -60 -26 -81 -12 -6 4 -16 17 -23 30 -10 19 -9 22 5 22 10 0 25 -7 35 -16 19 -17 39 -12 39 10 0 7 -17 24 -37 37 -26 16 -39 33 -41 50 -6 53 58 79 98 39z m100 -300 l0 -40 -240 0 -240 0 0 40 0 40 240 0 240 0 0 -40z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasheet);
export default __webpack_public_path__ + "static/media/datasheet.998c045befd1be99273e2500926b276d.svg";
export { ForwardRef as ReactComponent };